import styled from 'styled-components';

const StyledFileTableWrapper = styled.div`
  width: 100%;
  height: fit-content;
`;

export default StyledFileTableWrapper;
